import { Col, Row } from "antd";
import type { FC } from "react";

import { PrimaryButton, SecondaryButton } from "../../../../components/Buttons/components/ActionButton";
import { useTranslation } from "../../../../core/translations";

export type FormFooterProps = Readonly<{
    disabled: boolean;
    canSubmit: boolean;
    canCancel?: boolean;
    canRefreshPage?: boolean;
    onClick: Function;
    useContinue?: boolean;
}>;

export enum FormAction {
    SUBMIT,
    CANCEL,
    CONTINUE,
    REFRESH,
}

export const FormFooter: FC<FormFooterProps> = ({
    onClick,
    canSubmit,
    disabled,
    canCancel = true,
    canRefreshPage = false,
    useContinue = false,
}) => {
    const { t } = useTranslation();

    return (
        <Row gutter={15}>
            {canSubmit && !useContinue && (
                <Col>
                    <PrimaryButton name="save_form" disabled={disabled} onClick={() => onClick(FormAction.SUBMIT)}>
                        {t("common.save")}
                    </PrimaryButton>
                </Col>
            )}
            {canSubmit && useContinue && (
                <Col>
                    <PrimaryButton name="continue_button" disabled={disabled} onClick={() => onClick(FormAction.CONTINUE)}>
                        {t("button.continue")}
                    </PrimaryButton>
                </Col>
            )}
            {canCancel && (
                <Col>
                    <SecondaryButton name="cancel_button" onClick={() => onClick(FormAction.CANCEL)}>
                        {t("button.back")}
                    </SecondaryButton>
                </Col>
            )}
            {canRefreshPage && (
                <Col>
                    <SecondaryButton onClick={() => onClick(FormAction.REFRESH)}>{t("button.refresh")}</SecondaryButton>
                </Col>
            )}
        </Row>
    );
};
